import { useContext } from "react";
import LoadingContext from "../context/LoadingContext";

const useLoading = () => {
    const {
        isLoading,
        isFirstWOLoad,
        setIsLoading,
        setIsFirstWOLoad
        
    } = useContext(LoadingContext)

    return { isLoading, isFirstWOLoad, setIsLoading, setIsFirstWOLoad}
}

export default useLoading